// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"560":"5fe1e9ae","995":"d36176b4"}[chunkId] + ".js";
};